/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Name"
  
}) {
let professionalEmployeeProviderEmployeeResourceEmploymentContractPersonValueData = fromData.useDataFormat({ viewPath,
context: 'professional',
path: 'employee.provider.employee_resource.employment_contract.person',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width="auto"
 display="block"
 textOverflow="ellipsis"
 overflowX="hidden"
 overflowY="hidden"
 whiteSpace="nowrap"
 data="professional.employee.provider.employee_resource.employment_contract.person"
 format="/Data/format.js personName"
 text={professionalEmployeeProviderEmployeeResourceEmploymentContractPersonValueData}
/>
{children}
</React.Fragment>)
}